module.exports = __webpack_public_path__ + "img/placeholderimg.be65927a.jpeg";